import * as actionTypes from './../Audit_action.types';
import * as api from './../audit_api_services/VendorAudit.api';

export const getVendorWiseRecordRequest = () => ({
  type: actionTypes.GET_VENDOR_REQUEST,
});

export const getVendorWiseRecordSuccess = (data) => ({
type: actionTypes.GET_VENDOR_SUCCESS,
payload: data,
});

export const getVendorWiseRecordFailure = (error) => ({
type: actionTypes.GET_VENDOR_FAILURE,
payload: error,
});

export const getVendorWiseRecord = () => {
return async (dispatch) => {
  dispatch(getVendorWiseRecordRequest());
  try {
    const response = await api.fetchVendorWiseRecord();
    dispatch(getVendorWiseRecordSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getVendorWiseRecordFailure(error));
    return { success: false, message: error };
  }
};
};

export const getFilterVendorWiseRecordRequest = () => ({
  type: actionTypes.GET_VENDOR_REQUEST,
});

export const getFilterVendorWiseRecordSuccess = (data) => ({
type: actionTypes.GET_VENDOR_SUCCESS,
payload: data,
});

export const getFilterVendorWiseRecordFailure = (error) => ({
type: actionTypes.GET_VENDOR_FAILURE,
payload: error,
});

export const getFilterVendorWiseRecord = (from_date,to_date) => {
  return async (dispatch) => {
    dispatch(getFilterVendorWiseRecordRequest());
    try {
      const response = await api.fetchFilterVendorWiseRecord(from_date,to_date);
      dispatch(getFilterVendorWiseRecordSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getFilterVendorWiseRecordFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getVendorAuditDetailsRequest = () => ({
  type: actionTypes.GET_VENDOR_AUDIT_DETAILS_REQUEST,
});

export const getVendorAuditDetailsSuccess = (data) => ({
type: actionTypes.GET_VENDOR_AUDIT_DETAILS_SUCCESS,
payload: data,
});

export const getVendorAuditDetailsFailure = (error) => ({
type: actionTypes.GET_VENDOR_AUDIT_DETAILS_FAILURE,
payload: error,
});

export const getVendorAuditDetails = (id) => {
  return async (dispatch) => {
    dispatch(getVendorAuditDetailsRequest(id));
    try {
      const response = await api.get_vendor_audit_details(id);
      dispatch(getVendorAuditDetailsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getVendorAuditDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const updateVendorAuditDetailsRequest = (data) => ({
  type: actionTypes.UPDATE_VENDOR_AUDIT_DETAILS_REQUEST,
  payload: data,
});

export const updateVendorAuditDetailsSuccess = (data) => ({
type: actionTypes.UPDATE_VENDOR_AUDIT_DETAILS_SUCCESS,
payload: data,
});

export const updateVendorAuditDetailsFailure = (error) => ({
type: actionTypes.UPDATE_VENDOR_AUDIT_DETAILS_FAILURE,
payload: error,
});

export const updateVendorAuditDetails = (status,data) => {
  return async (dispatch) => {
    dispatch(updateVendorAuditDetailsRequest(data));
    try {
      const response = await api.updateVendorAudit(status,data);
      dispatch(updateVendorAuditDetailsSuccess(response));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateVendorAuditDetailsFailure(error));
      return { success: false, message: error.response.data.error };
    }
  };
};

export const uploadVendorAuditAttachment = (recordId, file, override = false) => {
  return async () => {
    try {
      const response = await api.uploadVendorAuditAttachment(recordId, file, override);
      return {
        success: true,
        message: response.message,
        attachments: response.attachments || [],
        drafts: response.drafts || [],
        total_bytes: response.total_bytes || 0,
      };
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to upload file";
      return {
        success: false,
        message,
        alreadyExists: Boolean(error?.response?.data?.already_exists),
      };
    }
  };
};

export const clearVendorAuditDrafts = (auditPk) => {
  return async () => {
    try {
      const response = await api.clearVendorAuditDrafts(auditPk);
      return { success: true, message: response.message };
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to clear drafts";
      return { success: false, message };
    }
  };
};

export const clearVendorAuditRowDrafts = (recordId) => {
  return async () => {
    try {
      const response = await api.clearVendorAuditRowDrafts(recordId);
      return {
        success: true,
        message: response.message,
        attachments: response.attachments || [],
        drafts: response.drafts || [],
        total_bytes: response.total_bytes || 0,
      };
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to remove attachment";
      return { success: false, message };
    }
  };
};

export const clearVendorAuditAttachments = (recordId) => {
  return async () => {
    try {
      const response = await api.clearVendorAuditAttachments(recordId);
      return {
        success: true,
        message: response.message,
        attachments: response.attachments || [],
      };
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to remove attachment";
      return { success: false, message };
    }
  };
};
export const fetchAttachmentFileRequest = (data) => ({
  type: actionTypes.FETCH_ATTACHMENT_FILE_REQUEST,
  payload: data,
});

export const fetchAttachmentFileSuccess = (data) => ({
type: actionTypes.FETCH_ATTACHMENT_FILE_SUCCESS,
payload: data,
});

export const fetchAttachmentFileFailure = (error) => ({
type: actionTypes.FETCH_ATTACHMENT_FILE_FAILURE,
payload: error,
});

export const fetchAttachmentFile = (status,data) => {
  return async (dispatch) => {
    dispatch(fetchAttachmentFileRequest(data));
    try {
      const response = await api.AttachmentFile(status,data);
      dispatch(fetchAttachmentFileSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(fetchAttachmentFileFailure(error));
      return { success: false, message: error };
    }
  };
};